import { Box, Chip, Paper, Stack, Typography } from "@mui/material"
import AppsRoundedIcon from "@mui/icons-material/AppsRounded"

const displayValue = (value) =>
  value === null || value === undefined || value === "" ? "Not reported" : value

const TerminalHealthInstalledApps = ({ applications }) => {
  const hasReportedApps = Array.isArray(applications)
  const apps = hasReportedApps ? applications : []

  return (
    <Paper
      component="section"
      aria-label="Installed Apps"
      variant="outlined"
      sx={{ mt: 3, p: { xs: 2, sm: 3 }, borderRadius: 3 }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
        <Box
          sx={{
            display: "flex",
            p: 1,
            borderRadius: 2,
            bgcolor: "#e8f4f4",
            color: "#126e73"
          }}
        >
          <AppsRoundedIcon />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography component="h3" variant="subtitle1" fontWeight={600}>
            Installed Apps
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Applications reported in the terminal’s latest health response.
          </Typography>
        </Box>
        {hasReportedApps && (
          <Chip label={`${apps.length} ${apps.length === 1 ? "app" : "apps"}`} size="small" />
        )}
      </Stack>

      {apps.length > 0 ? (
        <Box
          component="ul"
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "minmax(0, 1fr)",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(3, minmax(0, 1fr))"
            },
            gap: 2,
            p: 0,
            m: 0,
            listStyle: "none"
          }}
        >
          {apps.map((app, index) => (
            <Box
              component="li"
              key={`${app?.name}-${app?.code}-${index}`}
              sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, overflowWrap: "anywhere" }}
            >
              <Typography component="h4" variant="body1" fontWeight={600} mb={1.5}>
                {app?.name || "Unnamed application"}
              </Typography>
              <Box component="dl" sx={{ m: 0 }}>
                <Typography component="dt" variant="caption" color="text.secondary">Version</Typography>
                <Typography component="dd" variant="body2" sx={{ m: 0, mb: 1 }}>
                  {displayValue(app?.version)}
                </Typography>
                <Typography component="dt" variant="caption" color="text.secondary">Version code</Typography>
                <Typography component="dd" variant="body2" sx={{ m: 0 }}>
                  {displayValue(app?.code)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          {hasReportedApps ? "No installed apps were reported by this terminal." : "Installed app information has not been reported yet."}
        </Typography>
      )}
    </Paper>
  )
}

export default TerminalHealthInstalledApps
